import { render } from "./Sound.vue?vue&type=template&id=37b27721&scoped=true"
import script from "./Sound.vue?vue&type=script&lang=js"
export * from "./Sound.vue?vue&type=script&lang=js"

import "./Sound.vue?vue&type=style&index=0&id=37b27721&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37b27721"]])

export default __exports__